"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _SnetFooterColumns = _interopRequireDefault(require("./SnetFooterColumns"));
var _SnetFooterCopyright = _interopRequireDefault(require("./SnetFooterCopyright"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooter = () => {
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.snetFooterContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.snetFooter
  }, /*#__PURE__*/_react.default.createElement(_SnetFooterColumns.default, null), /*#__PURE__*/_react.default.createElement(_SnetFooterCopyright.default, null)));
};
var _default = exports.default = SnetFooter;